
import {Component, Prop, Vue} from 'vue-property-decorator';
import {SuggestionDataRegistry} from '../lib/SuggestionDataRegistry';

@Component({})
export default class SuggestionChoices extends Vue {
    @Prop() public selected ?: number|string;
    @Prop() public id ?: number;

    public getIconData(id: number|string) {
        return SuggestionDataRegistry.getQuestionData(id, "icons");
    }

    public getTextData(id: number | string) {
        return SuggestionDataRegistry.getQuestionData(id, "text");
    }
    public getIcon(iconName) {
        return SuggestionDataRegistry.getIconFullPath(iconName);
    }
    public isSelected(id) {
        // console.log(id, this.selected);
        return this.selected == id;

    }

    public hasTextSuggestions(id) {
        return SuggestionDataRegistry.hasQuestionSuggestionText(id);
    }

    public hasIconSuggestions(id) {
        return SuggestionDataRegistry.hasQuestionIcons(id);
    }

}
